export const guestRoute = () => '/guest'
export const guestTimeDiscountRoute = () => '/guest/time-discount'
export const guestRegistrationRoute = () => '/guest/registration'
export const guestFinalRoute = () => '/guest/final'
